import { axiosInstance } from "../../axios-Instance";
import { getLoginToken } from "../../storage";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "../../react-query/constants";

async function getSectionAR() {
  const data = await axiosInstance({
    url: "/sectionAResponse",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data?.data;
}

const createSectionAResponse = async (formData: any) => {
  const data = await axiosInstance({
    url: "/sectionAResponse",
    method: "POST",
    data: formData,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

async function getAssessmentResponse() {
  const data = await axiosInstance({
    url: "/iassessmentResponse",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data?.data;
}

async function getMyAssessmentResponse() {
  const data = await axiosInstance({
    url: "/iassessmentResponse/me",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data?.data;
}

const createAssessmentResponse = async (formData: any) => {
  const data = await axiosInstance({
    url: "/iassessmentResponse",
    method: "POST",
    data: formData,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

const updateAssessmentResponse = async (formData: any) => {
  const data = await axiosInstance({
    url: `/iassessmentResponse/${formData["_id"]}`,
    method: "PUT",
    data: formData,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

const fastTrackAssessmentResponse = async (formData: any) => {
  const data = await axiosInstance({
    url: `/iassessmentResponse/fastTrack/${formData["_id"]}`,
    method: "PUT",
    data: formData,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

const deleteAssessmentResponse = async (formData: any) => {
  const data = await axiosInstance({
    url: `/iassessmentResponse/${formData}`,
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

export function useIAssessmentResponse() {
  const fallback: any = [];
  const { data = fallback } = useQuery({
    queryKey: [queryKeys.iassessmentResponse],
    queryFn: () => getAssessmentResponse(),
  });
  return data;
}

export function useMyIAssessmentResponse() {
  const fallback: any = [];
  const { data = fallback } = useQuery({
    queryKey: [queryKeys.userAssessmentResponse],
    queryFn: () => getMyAssessmentResponse(),
  });
  return data;
}

export function useCreateIAssessmentResponse() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => createAssessmentResponse(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.userAssessmentResponse]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}

export function useUpdateIAssessmentResponse() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => updateAssessmentResponse(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.userAssessmentResponse]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}

export function useFastTrackResponse() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => fastTrackAssessmentResponse(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.iassessmentResponse]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}

export function useDeleteIAssessmentResponse() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => deleteAssessmentResponse(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.iassessmentResponse]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}

export function useSectionAResponse() {
  const fallback: any = [];
  const { data = fallback } = useQuery({
    queryKey: [queryKeys.sectionAResponse],
    queryFn: getSectionAR,
  });
  return data;
}

export function useCreateSectionAResponse() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => createSectionAResponse(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.sectionAResponse]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}
